"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _reactSelect = _interopRequireDefault(require("react-select"));
var _reactSelectBoostrap = require("./reactSelectBoostrap4");
var _excluded = ["fieldApi", "fieldState", "onChange", "component"],
  _excluded2 = ["forwardedRef", "className", "field", "initial", "key"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var BasicReactSelect = exports["default"] = /*#__PURE__*/function (_React$Component) {
  function BasicReactSelect(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, BasicReactSelect);
    _this = _callSuper(this, BasicReactSelect, [props]);
    _this.handleChange = _this.handleChange.bind(_this);
    _this.fieldApi = _this.props.fieldApi;
    _this.valueCache = {};
    return _this;
  }
  (0, _inherits2["default"])(BasicReactSelect, _React$Component);
  return (0, _createClass2["default"])(BasicReactSelect, [{
    key: "handleChange",
    value: function handleChange(value) {
      var onChange = this.props.onChange;
      if (this.fieldApi) {
        this.fieldApi.setValue(value !== null ? value.value : null);
      }
      if (value !== null) {
        this.valueCache[value.value] = value.label;
      }
      if (onChange) {
        onChange(value);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        fieldApi = _this$props.fieldApi,
        fieldState = _this$props.fieldState,
        onChange = _this$props.onChange,
        component = _this$props.component,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var setValue = fieldApi.setValue,
        setTouched = fieldApi.setTouched;
      var forwardedRef = props.forwardedRef,
        className = props.className,
        field = props.field,
        initial = props.initial,
        key = props.key,
        rest = (0, _objectWithoutProperties2["default"])(props, _excluded2);
      rest.onBlur = function (e) {
        setTouched();
      };
      var value = null;
      if (this.props.value) {
        value = this.props.value;
      } else if (this.props.fieldState.value) {
        var v_value = this.props.fieldState.value;
        if (_.isObject(v_value) && v_value.value !== undefined) {
          value = v_value;
        } else {
          var label = v_value;
          if (this.props.options) {
            var found = _.find(this.props.options, function (o) {
              return o.value === v_value;
            });
            if (found) {
              label = found.label;
            }
          } else if (this.valueCache[v_value]) {
            label = this.valueCache[v_value];
          }
          value = {
            value: v_value,
            label: label
          };
        }
      }
      var Component = component;
      return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({
        styles: _reactSelectBoostrap.styles,
        onChange: this.handleChange
      }, rest, {
        value: value,
        className: "react-select-container",
        classNamePrefix: "react-select"
      }));
    }
  }]);
}(_react["default"].Component);
BasicReactSelect.defaultProps = {
  component: _reactSelect["default"]
};